import { render, staticRenderFns } from "./RecordOptions.vue?vue&type=template&id=6aac7b8e&scoped=true&"
import script from "./RecordOptions.vue?vue&type=script&lang=js&"
export * from "./RecordOptions.vue?vue&type=script&lang=js&"
import style0 from "./RecordOptions.vue?vue&type=style&index=0&id=6aac7b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac7b8e",
  null
  
)

export default component.exports